import {
	SET_QUERY_RESULTS,
	SET_BULK_EDIT_INFO,
	SET_BULK_EDIT_RUN_RESULTS,
	SET_PARTS_ORDERS,
	SET_BULK_IMPORT_RESULTS,
	SET_PARTS_VENDORS,
	UPDATE_SELECTED_QUERY_RESULTS,
	UPDATE_SELECT_ALL_QUERY_RESULTS,
	REMOVE_PARTS_ORDERS
} from './inventory-management-tool-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';
import { cloneDeep } from 'lodash';
import Vue from 'vue';
import gatherItems from '@/utils/gather-items';

const RUN_BULK_UPDATE_ACTION = 'runBulkUpdateAction';

const initialState = {
	queryResults: {},
	bulkEditInfo: {},
	bulkEditRunResults: {},
	partsOrders: {},
	bulkImportesults: {},
	partsVendors: {}
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'inventoryManagementTool',
	namespaced: true,
	state: cloneDeep(initialState),
	mutations: {
		[SET_QUERY_RESULTS](state, queryResults) {
			state.queryResults = queryResults;
		},
		[SET_BULK_EDIT_INFO](state, bulkEditInfo) {
			state.bulkEditInfo = bulkEditInfo;
		},
		[SET_BULK_EDIT_RUN_RESULTS](state, bulkEditRunResults) {
			state.bulkEditRunResults = bulkEditRunResults;
		},
		[SET_PARTS_ORDERS](state, partsOrders) {
			Vue.set(state.partsOrders, partsOrders.page + '', partsOrders);
		},
		[SET_BULK_IMPORT_RESULTS](state, bulkImportesults) {
			state.bulkImportesults = bulkImportesults;
		},
		[SET_PARTS_VENDORS](state, partsVendors) {
			state.partsVendors = partsVendors;
		},
		[UPDATE_SELECTED_QUERY_RESULTS](state, { ids, selected }) {
			state.queryResults.data = state.queryResults.data.map(item => {
				if (ids.includes(item.id)) {
					return { ...item, update: selected };
				}
				return item;
			});
		},
		[UPDATE_SELECT_ALL_QUERY_RESULTS](state, selectAll) {
			// state.queryResults.data.forEach(queryItem => {
			// 	Vue.set(queryItem, 'update', selectAll);
			// });
			state.queryResults.data = state.queryResults.data.map(
				queryItem => ({
					...queryItem,
					update: selectAll
				})
			);
		},
		[REMOVE_PARTS_ORDERS](state) {
			state.partsOrders = {};
		}
	},
	actions: {
		async getQuerySnapshotAction({ commit }, bulkEditId) {
			const snapShotResults = await api.get(
				buildRoute('/reportgenerator/bulkedit/{id}/data', {
					id: bulkEditId
				})
			);
			commit(SET_QUERY_RESULTS, snapShotResults);
		},
		async runQueryAction({ commit }, id) {
			const queryResults = await api.get(
				buildRoute('/reportgenerator/bulkedit/{id}/query', {
					id
				})
			);
			commit(SET_QUERY_RESULTS, queryResults);
		},
		async getBulkEditInfoAction({ commit }, id) {
			const bulkEditInfo = await api.get(
				buildRoute('/reportgenerator/bulkedit/{id}', {
					id
				})
			);
			commit(SET_BULK_EDIT_INFO, bulkEditInfo);
		},
		async runBulkUpdateAction({ commit }, payLoad) {
			const bulkEditRunResults = await api.post(
				buildRoute('/reportgenerator/bulkedit/{id}/update', {
					id: payLoad.bulkEditId
				}),
				payLoad
			);
			commit(SET_BULK_EDIT_RUN_RESULTS, bulkEditRunResults);
		},
		async runBulkDeactivateAction({ dispatch }, payLoad) {
			payLoad.updateFields = [
				{
					bulkEditId: payLoad.bulkEditId,
					reportGeneratorFieldId: 106,
					newValue: '0'
				}
			];
			await dispatch(RUN_BULK_UPDATE_ACTION, payLoad);
		},
		async getPartsOrdersAction(
			{ commit },
			{ companyId, searchParameters }
		) {
			const partsOrders = await api.get(
				buildRoute('/dealership/company/{id}/partsorders', {
					id: companyId,
					query: searchParameters
				})
			);
			commit(SET_PARTS_ORDERS, partsOrders);
		},
		resetPartsOrdersAction({ commit }) {
			commit(REMOVE_PARTS_ORDERS);
		},
		async runBulkImportAction({ commit }, payLoad) {
			const bulkImportResults = await api.post(
				buildRoute('/reportgenerator/bulkedit/{id}/import', {
					id: payLoad.bulkEditId
				}),
				payLoad
			);
			commit(SET_BULK_IMPORT_RESULTS, bulkImportResults);
		},
		async getVendorsAction({ commit }, { searchParameters, companyId }) {
			const partsVendors = await api.get(
				buildRoute('/dealership/company/{id}/vendors', {
					id: companyId,
					query: searchParameters
				})
			);
			commit(SET_PARTS_VENDORS, partsVendors);
		},
		async updateSelectedQueryResultsAction(
			{ commit },
			{ ids, bulkEditId, selected }
		) {
			await api.post(buildRoute('/reportgenerator/bulkedit/select'), {
				ids: ids,
				bulkEditId: bulkEditId,
				update: selected
			});
			commit(UPDATE_SELECTED_QUERY_RESULTS, {
				ids,
				selected
			});
		},
		async updateSelectAllQueryResultsAction(
			{ commit },
			{ bulkEditId, selected }
		) {
			await api.post(buildRoute('/reportgenerator/bulkedit/select'), {
				bulkEditId: bulkEditId,
				update: selected
			});
			commit(UPDATE_SELECT_ALL_QUERY_RESULTS, selected);
		}
	},
	getters: {
		queryResults: state => state.queryResults,
		bulkEditInfo: state => state.bulkEditInfo,
		bulkEditRunResults: state => state.bulkEditRunResults,
		partsOrdersItems: state => {
			const items = gatherItems(state.partsOrders);
			return items;
		},
		partsOrdersCount: state => {
			let count = 1;

			if (state.partsOrders && state.partsOrders[1]) {
				count = state.partsOrders[1].totalCount;
			}

			return count;
		},
		partsOrdersPageCount: state => {
			let count = 1;

			if (state.partsOrders && state.partsOrders[1]) {
				count = state.partsOrders[1].totalPageCount;
			}

			return count;
		},
		bulkImportesults: state => state.bulkImportesults,
		partsVendors: state => state.partsVendors,
		excludedPartIds: state => {
			return (
				state.queryResults?.data
					?.filter(item => !item.update)
					?.map(excludedPart => excludedPart.id) || []
			);
		},
		selectedPartIds: state => {
			return (
				state.queryResults?.data
					?.filter(item => item.update)
					?.map(p => p.id) || []
			);
		}
	}
};
